import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function ProductInstallments(props = {}) {
	return {
		componentName: 'ProductInstallments',
		componentId: uuidv4(),
		props: _.merge(
			{
				markers: [],
				message: 'Ou {installmentsNumber}x de {installmentValue}',
				installmentsCriteria: 'max-quantity',
			},
			props,
		),
	};
}
